<script>
	import Day from './Day.svelte';
	import { slots } from './slots.js';
</script>

<main>
	<h1>Prenotazione Colloqui</h1>
	{#each slots as slot}
	<div class="column">
		<h2>{new Intl.DateTimeFormat('it-IT', { dateStyle: 'full' }).format(new Date(slot.date))}</h2>
		<Day {slot} />
	</div>
	{/each}
</main>

<style>
	main {
		padding: 1em;
		max-width: 640px;
		margin: 0 auto;
		padding: 0 10px;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 2em;
		font-weight: 100;
	}

	h2 {
		color: #333;
		font-size: 1.5em;
		font-weight: 100;
		text-transform: capitalize;
	}
</style>